// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5888":"db695d18","7233":"db695d18","7237":"db695d18","7978":"db695d18"}[chunkId] + ".chunk.css";
};